import { FC, useEffect, useState, useRef, useMemo } from 'react';
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { FormProvider, useForm, useFormContext } from "react-hook-form";
// import { Box, Typography, TextField, CardContent, Grid, Stack, Drawer, CircularProgress, Tooltip, SelectChangeEvent, Button, Paper, IconButton, Badge, Chip, Radio } from '@mui/material';
import { Typography,CardContent, CircularProgress, Grid, Stack, SelectChangeEvent, Autocomplete, Chip, Box, Button, Checkbox, Divider, FormControlLabel, FormGroup, IconButton, InputAdornment, MenuItem, Modal, Radio, Select, Switch, TextField, Tooltip, Alert } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import EditIcon from '@mui/icons-material/Edit';
import SettingsIcon from '@mui/icons-material/Settings';
import SearchIcon from '@mui/icons-material/Search';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
// import CustomTextField from "../FormFields/CustomTextField";
// import CustomThemeTextField from "../FormFields/CustomThemeTextField";
import * as yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import moment from 'moment';

import { RadioProps } from '@mui/material/Radio';
import { styled } from '@mui/material/styles';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import HighlightOffTwoToneIcon from '@mui/icons-material/HighlightOffTwoTone';
import CheckCircleOutlineOutlinedIcon from '@mui/icons-material/CheckCircleOutlineOutlined';
import { makeStyles } from "@material-ui/core/styles";
import NavigateBeforeOutlinedIcon from '@mui/icons-material/NavigateBeforeOutlined';
import FileUploader from "../Invoice/FileUploader";
import SkuBarcodePanel from './SkuBarcodePanel';


// app utils

import { StyledCard } from '../AccountBasicInfo/AccountBacisInfo.styles';
import { useAppDispatch, useAppSelector } from "../../store/hooks";
import CustomSelect, { IOptions } from "../FormFields/CustomSelect";
import { StyledBoxLoader } from '../Invoice/Invoice.style';
import { Utils } from "../../utils/common-utils";
import { ApiStatus } from "../../utils/api.types";

// app imports
import { Inventory, InventoryFormInputs, InventoryNewFormInputs, IPurchaseDetails } from '../../utils/inventory.types';
import { addInventory, fetchInventoryById, updateInventory, fetchItemCategories, fetchItemSubCategories, fetchMeasuringUnits, fetchInventoryByAccountId, fetchItemSubCategoriesByCategory, fetchItemTags } from '../../store/inventoryStore/inventoryThunk';
import UnitsPacksEditor, { UnitsValue } from './UnitsPacksEditor';
import SkuVariantsSection, { SkuVariantsValue } from './SkuVariantsSection';
import CategoryModal from './CategoryModal';
import { fetchGstOptions } from '../../store/gstStore/gstThunk';
import { buildAuditChanges } from "../../utils/auditChanges";
import LoadingButton from '@mui/lab/LoadingButton/LoadingButton';
import { Height } from '@mui/icons-material';
import { Direction } from 'react-toastify/dist/utils';
import { toast } from 'react-toastify';
import { InfoIcon } from 'lucide-react';


// Label map of user-editable SKU fields for the audit log; derived/system fields are excluded.
const INVENTORY_AUDIT_FIELDS: Record<string, string> = {
  name: 'Name', description: 'Description', itemCode: 'Item Code', itemShort: 'Short Name',
  hsnCode: 'HSN/SAC', mrp: 'MRP', purchasePrice: 'Purchase Price', salePrice: 'Selling Price',
  wholeSalePrice: 'Wholesale Price', wholeSaleMinQty: 'Wholesale Min Qty', conversionRate: 'Conversion Rate',
  gst: 'GST', discountPercent: 'Discount %', discountAmount: 'Discount Amount', discountAboveQty: 'Discount Above Qty',
  openingStock: 'Opening Stock', lowStockQuantity: 'Low Stock Qty', reorderQty: 'Reorder Qty',
  brand: 'Brand', color: 'Color',
};

const style = {
  position: 'absolute' as 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  transition: '0ms',
  width: 1000,
  borderRadius: 2,
  bgcolor: 'background.paper',
  border: 'none',
  boxShadow: 24,
};

const useStyles = makeStyles({
  paper: {
    border: "1.5px solid #e9ecf1",
    width: '108%',
    boxShadow: 'none',
    marginLeft: '-6px',
    borderRadius: 7
  }
});
const BpIcon = styled('span')(({ theme }) => ({
  borderRadius: '50%',
  width: 16,
  height: 16,
  boxShadow:
    theme.palette.mode === 'dark'
      ? '0 0 0 1px rgb(16 22 26 / 40%)'
      : 'inset 0 0 0 1px rgba(16,22,26,.2), inset 0 -1px 0 rgba(16,22,26,.1)',
  backgroundColor: theme.palette.mode === 'dark' ? '#394b59' : '#f5f8fa',
  backgroundImage:
    theme.palette.mode === 'dark'
      ? 'linear-gradient(180deg,hsla(0,0%,100%,.05),hsla(0,0%,100%,0))'
      : 'linear-gradient(180deg,hsla(0,0%,100%,.8),hsla(0,0%,100%,0))',
  '.Mui-focusVisible &': {
    outline: '2px auto rgba(19,124,189,.6)',
    outlineOffset: 2,
  },
  'input:hover ~ &': {
    backgroundColor: theme.palette.mode === 'dark' ? '#30404d' : '#ebf1f5',
  },
  'input:disabled ~ &': {
    boxShadow: 'none',
    background:
      theme.palette.mode === 'dark' ? 'rgba(57,75,89,.5)' : 'rgba(206,217,224,.5)',
  },
}));

const BpCheckedIcon = styled(BpIcon)({
  backgroundColor: '#137cbd',
  backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
  '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage: 'radial-gradient(#fff,#fff 28%,transparent 32%)',
      content: '""',
  },
  'input:hover ~ &': {
      backgroundColor: '#106ba3',
  },
});

// Inspired by blueprintjs
function BpRadio(props: RadioProps) {
  return (
      <Radio
      disableRipple
      color="default"
      checkedIcon={<BpCheckedIcon />}
      icon={<BpIcon />}
      {...props}
      />
  );
}

// Schema to validate inventory form.
const schema = yup.object().shape({
  name: yup.string().required("Item Name is required")
});

interface InventoryProps {
  type?: string;
  model?: boolean;
  onClose?: () => void;
}

interface InventoryNewFormTest {
  name: string;
  description?: string;
}

// Estimate component. 
const InventoryFormNew: FC<InventoryProps> = ({ type, model, onClose }) => {
  const { pathname } = useLocation();
  const { inventoryId } = useParams();
  const isEditing = inventoryId ? true : false;

  // use form
  const methods = useForm<InventoryNewFormInputs>({
    resolver: yupResolver(schema),
  });
  // use form Test
  const methods2 = useForm<InventoryNewFormTest>({
    resolver: yupResolver(schema),
  });

  const classes = useStyles();
  const [wholesale, setWholesale] = useState(false);
  const [lowStock, setLowStock] = useState(false);
  // Unit the low-stock threshold is entered in; null = base unit.
  const [lowStockUnitValue, setLowStockUnitValue] = useState<any>(null);
  // Saved unit id on edit-load, resolved to an option once the unit list arrives.
  const [lowStockUnitId, setLowStockUnitId] = useState("");
  const [selectedIndex, setSelectedIndex] = useState(1);
  const [itemType1, setItemType1] = useState(1);
  const [images, setImages] = useState<File[]>([]);

  // States
  const { inventories, status } = useAppSelector(state => state.inventories);
  const inventoryDetails = useAppSelector(state => state.inventories.inventoryDeatils);
  const { selectedAccount } = useAppSelector(state => state.auth);
  const { subCategories } = useAppSelector(state => state.inventories);
  const { tags: masterTags } = useAppSelector(state => state.inventories);

  // form data states
  const formRef = useRef<any>();
  const [isLoading, setIsLoading] = useState(false);
  const [isformLoaded, setIsFormLoaded] = useState(false);
  const [newInventoryId, setNewInventoryId] = useState('');
  // const [inventoryDetails, setInventoryDetails] = useState<Inventory>();
  const [open, setOpen] = useState<Array<boolean>>([false, false, false, false]);
  const [stockAsOfDate, setStockAsOfDate] = useState<Date>(new Date());
  const [state, setSate] = useState('true');
  const [taxRateOptions, setTaxRateOptions] = useState<IOptions[]>([]);
  const [selectedTaxRateValue, setSelectedTaxRateValue] = useState("");
  const [itemCategoryOptions, setItemCategoryOptions] = useState<IOptions[]>([]);
  const [itemSubCategoryOptions, setItemSubCategoryOptions] = useState<IOptions[]>([]);
  const [measuringUnitOptions, setMeasuringUnitOptions] = useState<IOptions[]>([]);

  const [skuOptions, setSkuOptions] = useState<IOptions[]>([]);
  

  const [itemCategoryId, setItemCategoryId] = useState("");
  const [itemCategoryValue, setItemCategoryValue] = useState(null);
  const [itemSubCategoryId, setItemSubCategoryId] = useState("");
  const [itemSubCategoryValue, setItemSubCategoryValue] = useState(null);
  const [itemMeasuringUnitId, setItemMeasuringUnitId] = useState("");
  const [itemMeasuringUnitValue, setItemMeasuringUnitValue] = useState(null);
  const [itemPurchaseUnitValue, setItemPurchaseUnitValue] = useState(null);
  const [itemPurchaseUnitId, setItemPurchaseUnitId] = useState("");

  const [itemMeasuringSecondaryUnitId, setItemMeasuringSecondaryUnitId] = useState("");
  
  const [itemType, setItemType] = useState('Product');
  const [itemTypeProductChipColor, setIiemTypeProductChipColor] = useState('default');
  const [itemTypeServiceChipColor, setIiemTypeServiceChipColor] = useState('default');
  const [parentSkus, setParentSkus] = useState([]);
  const [selectedParentSkuTags, setSelectedParentSkuTags] = useState([]);
  // Tags selected for this item, sourced from the Tag master (stored as tag ids)
  const [selectedTagIds, setSelectedTagIds] = useState<string[]>([]);

  // Category modal states
  const [categoryModalOpen, setCategoryModalOpen] = useState(false);
  const [isSubCategoryModal, setIsSubCategoryModal] = useState(false);
  const [editingCategory, setEditingCategory] = useState(null);
  const [editingSubCategory, setEditingSubCategory] = useState(null);

  const [purchaseDetails, setPurchaseDetails] = useState<IPurchaseDetails>();

  // Units & Packs (base unit + unitConversions keyed by MeasuringUnit id).
  const [unitsValue, setUnitsValue] = useState<UnitsValue>({ baseUnit: "", baseUnitName: "", unitConversions: {} });
  const [unitsInitial, setUnitsInitial] = useState<any>(undefined);
  // Units this item can express a threshold in: its base unit plus any pack conversions.
  const lowStockUnitOptions = useMemo(() => {
    const ids = [unitsValue.baseUnit, ...Object.keys(unitsValue.unitConversions || {})].filter(Boolean);
    return measuringUnitOptions.filter((o: any) => ids.some((id) => String(id) === String(o.value)));
  }, [unitsValue, measuringUnitOptions]);

  useEffect(() => {
    if (!lowStockUnitId) return;
    const match = lowStockUnitOptions.find((o: any) => String(o.value) === lowStockUnitId);
    if (match) setLowStockUnitValue(match);
  }, [lowStockUnitId, lowStockUnitOptions]);
  // Stock-tracking flags.
  const [isStockTracked, setIsStockTracked] = useState(true);
  const [isBatchTracked, setIsBatchTracked] = useState(false);

  // Variants (per-SKU own copy; a master set only prefills them).
  const [variantsValue, setVariantsValue] = useState<SkuVariantsValue>({ variantsEnabled: false, variants: [] });
  const [variantsInitial, setVariantsInitial] = useState<any>(undefined);

  const [gst, setGst] = useState("");
  const [mrpWarning, setMrpWarning] = useState("");
  const [pendingSubCategoryId, setPendingSubCategoryId] = useState<string | null>(null);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();


  const handleListItemClick = (index: number) => {
    setSelectedIndex(index);
  };

  const handleDateChange = (newValue: Date | null, name: string | undefined) => {
    if (newValue) {
      setStockAsOfDate(newValue);
    }
  };

  const handleItemTypeClick = (e: any, name: string) => {
    console.log(name);
    console.log(e);
    const field_name = e.target.name;
    if (name) {
      setItemType(name);
      methods.setValue('itemType', name);
      // if (field_name == 'Product') {
      //   setIiemTypeProductChipColor('primary')
      //   setIiemTypeServiceChipColor('default')
      // }
      // if (field_name == 'Service') {
      //   setIiemTypeServiceChipColor('primary')
      //   setIiemTypeProductChipColor('default')
      // }
    }
  }

  const handleOpenCategoryModal = (forSubCategory = false, editCategory: any = null, editSubCategory: any = null) => {
    console.log('handleOpenCategoryModal called with:', { forSubCategory, editCategory, editSubCategory });
    setIsSubCategoryModal(forSubCategory);
    setEditingCategory(editCategory);
    setEditingSubCategory(editSubCategory);
    setCategoryModalOpen(true);
  };

  const handleCloseCategoryModal = () => {
    setCategoryModalOpen(false);
    setIsSubCategoryModal(false);
    setEditingCategory(null);
    setEditingSubCategory(null);
  };

  const refreshCategoriesData = () => {
    // Refresh categories
    setItemCategoryOptions([]);
    dispatch(fetchItemCategories()).unwrap().then(async (data) => {
      if (data) {
        if (data.length > 0) {
          const options: IOptions[] = [];
          await data.forEach(async (item: string | any) => {
            options.push({ label: item.name, value: item._id });
          });
          setItemCategoryOptions(options);
        }
      }
    });

    // Refresh subcategories if category is selected
    if (itemCategoryId) {
      dispatch(fetchItemSubCategoriesByCategory(itemCategoryId));
    }
  };

  //Method to handle invoice form submit.
  const onSubmit = async (data: InventoryNewFormInputs) => {
    console.log("onSubmit Called ======== ");
    console.log(data);

    // Block save when any variant is missing its sale price (flat ₹ or percent %).
    if (variantsValue.variantsEnabled) {
      const invalid = variantsValue.variants.find(
        (v) => v.salePrice === "" || v.salePrice === null || Number(v.salePrice) <= 0
      );
      if (invalid) {
        const kind = invalid.salePriceType === "percent" ? "percent value" : "sale price";
        toast.error(`Enter a ${kind} for variant "${invalid.name || "Unnamed"}"`);
        return;
      }
    }

    if (data) {
      data.account = selectedAccount._id;
      data.stockAsOfDate = stockAsOfDate.toString();
      if (data.subCategory == '') delete data.subCategory;
      if (data.category == '') delete data.category;
      // if (data.baseUnit == '') delete data.baseUnit;
      // if (data.secondaryUnit == '') delete data.secondaryUnit;
      if (data.gst == '') delete data.gst;

      data.itemType = itemType1 === 1 ? "Product" : itemType1 === 2 ? "Service" : "Raw Material";
      data.parentSkus = (parentSkus && parentSkus.length > 0 ) ? parentSkus : [];

      // Units & Packs -> base unit (id) + conversions keyed by unit id. Retire conversionRate.
      if (unitsValue.baseUnit) {
        (data as any).baseUnit = unitsValue.baseUnit;
        (data as any).baseUnitName = unitsValue.baseUnitName;
      } else {
        delete (data as any).baseUnit;
        delete (data as any).baseUnitName;
      }
      (data as any).unitConversions = unitsValue.unitConversions || {};
      delete (data as any).conversionRate;

      // Backend converts lowStockQuantity to base units using this; omit = already base.
      if (lowStockUnitValue?.value) (data as any).lowStockUnit = lowStockUnitValue.value;
      else delete (data as any).lowStockUnit;

      (data as any).isStockTracked = isStockTracked;
      (data as any).isBatchTracked = isBatchTracked;
      // Barcode type — default to 'none' when the user hasn't chosen one (no auto-generate).
      (data as any).barcodeMode = data.barcodeMode || 'none';
      // data.crossSellSkus = (crossSellSkus && crossSellSkus.length > 0 ) ? parentSkus : [];
      // data.upSellSkus = (upSellSkus && upSellSkus.length > 0 ) ? parentSkus : [];
      // Tags selected from the Tag master (stored as tag ids on the SKU)
      (data as any).tags = (selectedTagIds && selectedTagIds.length > 0) ? selectedTagIds : [];

      // Variants — this SKU's OWN copy (no ref to the master set).
      (data as any).variantsEnabled = variantsValue.variantsEnabled;
      (data as any).variants = variantsValue.variantsEnabled ? variantsValue.variants : [];

    }

    console.log("final form data ===> ", data);

    try {
      if (!isEditing) {
        console.log("creating new inventory")
        await dispatch(addInventory(data)).unwrap().then(async (data) => {
          if (data) {
            console.log(data);
            navigate('/inventory');
          }
        });
      } else {
        console.log("updating existing Inventory ....")
        if (inventoryId) {
          // The loaded record is nested; flatten it to mirror the submitted (flat) payload
          // so buildAuditChanges compares like-for-like. Only real user edits are audited.
          const originalFlat: any = {
            name: inventoryDetails.name,
            description: inventoryDetails.description,
            itemCode: inventoryDetails.itemCode,
            itemShort: inventoryDetails.itemShort,
            hsnCode: inventoryDetails.hsnCode,
            mrp: inventoryDetails.mrp,
            purchasePrice: inventoryDetails.purchase?.price,
            salePrice: inventoryDetails.sale?.price,
            wholeSalePrice: inventoryDetails.wholeSale?.price,
            wholeSaleMinQty: inventoryDetails.wholeSale?.minQty,
            conversionRate: inventoryDetails.conversionRate,
            gst: inventoryDetails.gst?._id,
            discountPercent: inventoryDetails.discount?.discountPercent,
            discountAmount: inventoryDetails.discount?.discountAmount,
            discountAboveQty: inventoryDetails.discount?.discountAboveQty,
            openingStock: inventoryDetails.stock?.openingStock,
            lowStockQuantity: inventoryDetails.stock?.lowStockQuantity,
            reorderQty: inventoryDetails.stock?.reorderQty,
            brand: inventoryDetails.brand,
            color: inventoryDetails.color,
          };
          (data as any)._auditChanges = buildAuditChanges(originalFlat, data, INVENTORY_AUDIT_FIELDS);
          await dispatch(updateInventory({ id: inventoryId, inventoryPayload: data })).unwrap().then( (responseData) => {
            if (responseData.message) onCancel();
          });
          setNewInventoryId(inventoryId)
        }
      }
    } catch (error: any) {
      // Empty catch block. 
    }
  };

  // Method to handle Cancel button click.
  const onCancel = () => {
    methods.reset();
    const cancelLink = `/inventory`;
    navigate(cancelLink);
  };

  // useEffect(() => {
  //   dispatch(fetchGstOptions()).unwrap().then(async (data) => {
  //     if (data) {
  //       if (data.length > 0) {
  //         await data.forEach(async (item: string | any) => {
  //           setTaxRateOptions((taxRateOptions: any) => ([...taxRateOptions, { label: item.lable, value: item._id }]));
  //         });
  //       }
  //     }
  //   });
  // }, []);

  useEffect(() => {

    let isMounted = true;
    const getItemCategories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchItemCategories());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setItemCategoryOptions(options);
        }
      }
    }

    const getTaxRates = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchGstOptions());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.lable, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setTaxRateOptions(options);
        }
      }
    }

    const getMeasuringUnits = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchMeasuringUnits());
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: `${item.name} (${item.code})`, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setMeasuringUnitOptions(options);
        }
      }
    }

    const getInventories = async () => {
      let options: IOptions[] = [];
      const data: any = await dispatch(fetchInventoryByAccountId(selectedAccount._id));
      console.log(data);
      if (data.payload.length > 0) {
        await data.payload.forEach(async (item: string | any) => {
          options.push({ label: item.name, value: item._id })  
        });
        if (isMounted && options.length > 0) {
          setSkuOptions(options);
        }
      }
    }

    getItemCategories();
    getMeasuringUnits();
    getTaxRates();
    getInventories();
    dispatch(fetchItemTags());
    return () => {
      isMounted = false;
    };

  }, []);

  const getItemSubCategory = async (catgoryId:any) => {
    let options: IOptions[] = [];
    const data: any = await dispatch(fetchItemSubCategories(catgoryId));
    if (data.payload.length > 0) {
      await data.payload.forEach(async (item: string | any) => {
        options.push({ label: item.name, value: item._id })  
      });
      if (options.length > 0) {
        setItemSubCategoryOptions(options);
      }
    }
    return options;
  }

  useEffect(() => {
    console.log("Called useEffect after onChangeItemCategoryHandler -----");
    console.log(itemCategoryId);
    if (itemCategoryId) {
      console.log("insdie if else itemCategoryId", itemCategoryId);
      methods.setValue("subCategory", '');
      // setItemSubCategoryId('');
      dispatch(fetchItemSubCategoriesByCategory(itemCategoryId));
    }
  }, [itemCategoryId, dispatch]);

  // Sync Redux subCategories to local itemSubCategoryOptions
  useEffect(() => {
    if (subCategories && Array.isArray(subCategories)) {
      const options: IOptions[] = subCategories.map(item => ({
        label: item.name,
        value: item._id
      }));
      setItemSubCategoryOptions(options);

      // If there's a pending subcategory to set, set it now
      if (pendingSubCategoryId && options.length > 0) {
        const subCategoryOption = options.find((item: any) => item.value === pendingSubCategoryId);
        if (subCategoryOption) {
          onChangeSubCategory(subCategoryOption);
          setPendingSubCategoryId(null); // Clear pending
        }
      }
    }
  }, [subCategories, pendingSubCategoryId]);

  // useEffect(() => {
  //   dispatch(fetchMeasuringUnits()).unwrap().then(async (data) => {
  //     if (data) {
  //       if (data.length > 0) {
  //         console.log(data);
  //         await data.forEach(async (item: string | any) => {
  //           console.log(item);
  //           setMeasuringUnitOptions((unitOptions: any) => ([...unitOptions, { label: `${item.name}(${item.unitCode})`, value: item._id }]));
  //         });
  //       }
  //     }
  //   });
  // }, []);

  // Reset all form state on item change: the route component is reused, so the previous item's fields would bleed through.
  useEffect(() => {
    methods.reset();
    setUnitsInitial(undefined);
    setUnitsValue({ baseUnit: "", baseUnitName: "", unitConversions: {} });
    setVariantsInitial(undefined);
    setVariantsValue({ variantsEnabled: false, variants: [] });
    setItemCategoryId('');
    setItemCategoryValue(null);
    setItemSubCategoryId('');
    setItemSubCategoryValue(null);
    setItemSubCategoryOptions([]);
    setSelectedTagIds([]);
    setParentSkus([]);
    setSelectedParentSkuTags([]);
    setIsStockTracked(true);
    setIsBatchTracked(false);
  }, [inventoryId]); // eslint-disable-line react-hooks/exhaustive-deps

  // fetch current inventory details on edit
  useEffect(() => {
    if (inventoryId) {
      dispatch(fetchInventoryById(inventoryId));
    }
  }, [inventoryId, dispatch]);

  //Set edit estimate data in case of edit.
  useEffect(() => {
    const setInitialData = async () => {
      console.log(inventoryDetails);
      console.log(isEditing);
      try {
        // Hydrate only from this item's own fetch — redux may still hold the previous item's details.
        if (inventoryDetails && isEditing && String(inventoryDetails._id || '') === String(inventoryId || '')) {
          console.log("inside isEditing and inventoryDetails ===> ");
          console.log(isEditing);
          setIsFormLoaded(true);
          setIsLoading(true);


          let _itemType = inventoryDetails.itemType == "Product" ? 1 : inventoryDetails.itemType == "Raw Material" ? 3 : 2;
          methods.setValue('itemType', String(_itemType));
          setItemType1(_itemType);
          // Raw Material (3) reuses the Product layout panel (selectedIndex 1); Service uses 2.
          setSelectedIndex(_itemType === 2 ? 2 : 1);
          methods.setValue('name', inventoryDetails.name);
          methods.setValue("description", inventoryDetails.description);

          // methods.setValue("category", inventoryDetails.category);
          // methods.setValue("subCategory", inventoryDetails.subCategory);

          methods.setValue('itemCode', inventoryDetails.itemCode);
          methods.setValue('itemShort', inventoryDetails.itemShort);
          methods.setValue("hsnCode", inventoryDetails.hsnCode);

          methods.setValue('mrp', inventoryDetails.mrp);

          if (inventoryDetails.purchase) { 
            methods.setValue('purchasePrice', inventoryDetails.purchase.price);
            methods.setValue('purchaseWithTax', inventoryDetails.purchase.purchaseWithTax);
            // methods.setValue('purchaseUnit', inventoryDetails.purchaseUnit);
          }

          if (inventoryDetails.sale) {
            methods.setValue('salePrice', inventoryDetails.sale.price);
            methods.setValue('saleWithTax', inventoryDetails.sale.withTax);
            // methods.setValue('saleUnit', inventoryDetails.saleUnit);
          }

          // Hydrate Units & Packs from the saved SKU (ids).
          setUnitsInitial({
            baseUnit: inventoryDetails.baseUnit?._id || inventoryDetails.baseUnit || '',
            unitConversions: inventoryDetails.unitConversions || {},
          });
          setIsStockTracked(inventoryDetails.isStockTracked !== false);
          setIsBatchTracked(!!inventoryDetails.isBatchTracked);

          // Hydrate Variants (SKU's own saved copy).
          setVariantsInitial({
            variantsEnabled: !!(inventoryDetails as any).variantsEnabled,
            variants: (inventoryDetails as any).variants || [],
          });

          if (inventoryDetails.wholeSale) {
            methods.setValue('wholeSalePrice', inventoryDetails.wholeSale.price);
            methods.setValue('wholeSalePriceWithTax', inventoryDetails.wholeSale.withTax);
            methods.setValue('wholeSaleMinQty', inventoryDetails.wholeSale.minQty);
          }

          methods.setValue("gst", inventoryDetails.gst?._id);
          methods.setValue("taxRate", inventoryDetails.gst?._id);
          setSelectedTaxRateValue(inventoryDetails.gst?._id);

          // Barcode type (Phase 8) — restore the saved mode so the panel shows it, not 'none'.
          methods.setValue('barcodeMode', (inventoryDetails as any).barcodeMode || 'none');

          if (inventoryDetails.discount) {  
            methods.setValue('discountPercent', inventoryDetails.discount.discountPercent);
            methods.setValue('discountAmount', inventoryDetails.discount.discountAmount);
            methods.setValue('discountAboveQty', inventoryDetails.discount.discountAboveQty);
          }

          if (inventoryDetails.stock) {
            methods.setValue('openingStock', inventoryDetails.stock.openingStock);
            methods.setValue('stockAsOfDate', inventoryDetails.stock.stockAsOfDate);
            methods.setValue('lowStockWarning', inventoryDetails.stock.lowStockWarning);
            // Show what the user typed ("2"), not the stored base value ("1500").
            methods.setValue('lowStockQuantity', inventoryDetails.stock.lowStockQtyInput ?? inventoryDetails.stock.lowStockQuantity);
            methods.setValue('reorderQty', inventoryDetails.stock.reorderQty);
            methods.setValue('isRefrigerated', inventoryDetails.stock.isRefrigerated);
            if (inventoryDetails.stock.lowStockQuantity) setLowStock(true);
            setLowStockUnitId(inventoryDetails.stock.lowStockUnit ? String(inventoryDetails.stock.lowStockUnit) : "");
          }

          if (inventoryDetails.storeLocation) {
            methods.setValue('storeLocation', inventoryDetails.storeLocation.storeLocation);
            methods.setValue('storeName', inventoryDetails.storeLocation.storeName);
          }
          methods.setValue('brand', inventoryDetails.brand);
          methods.setValue('color', inventoryDetails.color);

          setGst(inventoryDetails.gst?._id || '');

          if (inventoryDetails.category) {
            var categoryValue = getCategoryOption(inventoryDetails.category?._id);
            console.log(categoryValue)
            onChangeCategory(categoryValue, true) // Pass true to skip clearing subcategory
          }

          if (inventoryDetails.subCategory) {
            // Set pending subcategory ID - will be set once subcategories load
            setPendingSubCategoryId(inventoryDetails.subCategory?._id);
          }

          if (inventoryDetails.sale && inventoryDetails.sale.unit) {
            var saleOptionValue = getUnitOptionValue(inventoryDetails.sale.unit?._id);
            console.log(saleOptionValue)
            onChangeSaleUnit(saleOptionValue)
          }
          
          if (inventoryDetails.purchase && inventoryDetails.purchase.unit) {
            var purchaseOptionValue = getUnitOptionValue(inventoryDetails.purchase.unit?._id);
            console.log(purchaseOptionValue)
            onChangePurchaseUnit(purchaseOptionValue)
          }

          let _parentSkuIds;
          let _parenteSkuTags;
          if (inventoryDetails.parentSkus && inventoryDetails.parentSkus.length > 0) {
            _parentSkuIds = inventoryDetails.parentSkus.map((sku:any) => sku._id)
            _parenteSkuTags = inventoryDetails.parentSkus.map((sku:any) => {return {value: sku._id, label: sku.name} })
          } else {
            _parentSkuIds = [];
            _parenteSkuTags = []
          }
          setParentSkus(_parentSkuIds);
          setSelectedParentSkuTags(_parenteSkuTags);

          // Load tags (stored as ids on the SKU; populated docs are handled too)
          if (inventoryDetails.tags && inventoryDetails.tags.length > 0) {
            setSelectedTagIds(inventoryDetails.tags.map((t: any) => (typeof t === 'string' ? t : t._id)));
          } else {
            setSelectedTagIds([]);
          }

          setIsLoading(false);
          setIsFormLoaded(false);
        }
      } catch (error: any) {
        console.log("setInitialData catch block called");
        console.log(error);
      }
    };

    if (Object.keys(inventoryDetails).length > 0) setInitialData();
  }, [methods, dispatch, inventoryDetails, isEditing, selectedAccount, type]);

  const onChangeCategory = (data: any, skipClearSubCategory = false) => {
    console.log(data);
    methods.setValue("category", data.value);

    console.log(isEditing);

    // Fetch subcategories for the selected category
    if (data && data.value) {
      dispatch(fetchItemSubCategoriesByCategory(data.value));
      setItemCategoryId(data.value);
    }

    // Only clear subcategory if not loading initial data
    if (!skipClearSubCategory) {
      setItemSubCategoryId('');
      setItemSubCategoryValue(null);
      setItemSubCategoryOptions([]);
      methods.setValue("subCategory", '');
    }

    setItemCategoryValue(data);
    setItemCategoryId(data.value);
  }

  const onChangeItemCategoryHandler = (event: any, value: any) => {
    console.log("Called onChangeItemCategoryHandler -----");
    methods.setValue("category", event.target.value);
    setItemCategoryId(event.target.value);

    methods.setValue("subCategory", '');
    setItemSubCategoryId('');
    // setItemSubCategoryOptions([]);
    console.log(itemCategoryId);
    
  }

  const onChangeSubCategory = (data: any) => {
    console.log(data);
    methods.setValue("subCategory", data.value);
    setItemSubCategoryValue(data)
    setItemSubCategoryId(data.value);
  }

  const onChangeSaleUnit = (data: any) => {
    console.log(data);
    console.log(data);
    setItemMeasuringUnitValue(data)
    setItemMeasuringUnitId(data.value);
    methods.setValue('saleUnit', data.value)
  }

  const onChangePurchaseUnit = (data: any) => {
    console.log(data);
    setItemPurchaseUnitValue(data)
    setItemPurchaseUnitId(data.value);
    methods.setValue('purchaseUnit', data.value)
  }

  const getCategoryOption = (id: any) => {
    console.log(itemCategoryOptions);
    console.log(id);
    let categoryOption = itemCategoryOptions.find((item: any) => item.value == id);
    console.log(categoryOption);
    return categoryOption ? categoryOption : {}
  }
  const getSubCategoryOption = (id: any, categoryId: any) => {
    console.log(itemSubCategoryOptions);
    console.log(id);

    var _options;
    if (itemSubCategoryOptions.length == 0) {
      // _options = getItemSubCategory(categoryId);
    }
    let subCategoryOption = itemSubCategoryOptions.find((item: any) => item.value == id);
    console.log(subCategoryOption);
    return subCategoryOption ? subCategoryOption : {}
  }

  const getUnitOptionValue = (id: any) => {
    console.log(measuringUnitOptions);
    console.log(id);
    let unitOption = measuringUnitOptions.find((item: any) => item.value == id);
    console.log(unitOption);
    return unitOption ? unitOption : {}
  }

  const onChangeTagSkus = (data: any) => {
    console.log(data);
    setSelectedParentSkuTags(data);
    const tagedSkus = data.map((item:any) => item.value);
    const uniqueArray = [...new Set(tagedSkus)]
    let arrayValue:any = []
    uniqueArray.forEach((item) => { arrayValue.push(String(item));});
    if (uniqueArray && uniqueArray.length > 0) {
      setParentSkus(arrayValue);
    }
  }

  return (
      <FormProvider {...methods}>
        
        {/* <CardContent className={'invoiceContent'}> */}
          {/* <Typography className={'cardHeader'} variant="body1" >
            <Box>{isEditing ? "Edit Inventory" : "Create New Item"}</Box>
          </Typography> */}

          <Box component="form" onSubmit={methods.handleSubmit(data => onSubmit(data))} ref={formRef} noValidate sx={model ? style : {borderRadius:'12px', border:'3px solid #e9ecf1',backgroundColor:'#fff',margin:0, mt:1}}>
            {isformLoaded && <StyledBoxLoader sx={{ mt: 1 }}><CircularProgress color="inherit" /></StyledBoxLoader>}
            <LocalizationProvider dateAdapter={AdapterDateFns}>
            <Grid container spacing={2} p={2}>
              <Grid {...{ xs: 12, sm: 8, md: 4, lg: 12, p:2}} style={{borderBottom: "1px solid grey", borderBottomStyle: 'dashed', borderTopLeftRadius:8,borderTopRightRadius:8,height:60}} >
                <div style={{float:'right',marginTop:-5,marginRight:-5}}>
                  {<LoadingButton
                    className={'buttonContainedRoot'}
                    size='small'
                    type="submit"
                    name={'submit'}
                    loading={status === ApiStatus.LOADING}
                    style={{ color:'#488dff',backgroundColor:'#fff',border:'0.5px solid #488dff',height:35,borderRadius:7, marginRight: 10}}
                    variant="contained"
                  >
                    { isEditing ? "Update" : "Create"}
                  </LoadingButton>}
                  <LoadingButton
                    className={'buttonContainedRoot'}
                    size='small'
                    type="button"
                    name={'Cancel'}
                    onClick={() => {
                      methods.reset();
                      onCancel();
                    }} 
                    style={{ color: '#488dff', backgroundColor: '#fff', border: '0.5px solid #488dff', height: 35, borderRadius: 7 }}
                    variant="contained"
                  >
                    {`Cancel`}
                  </LoadingButton>
                </div>
                
                <h3  style={{marginTop:-1,fontWeight:600}}>{ isEditing ? "Edit Item" : "Create New Item"}</h3>
              </Grid>
              <Grid item xs={2} pr={2}>
                <h5 className='c-label' style={{fontSize:14,marginBottom:10}}>Item Type*</h5>
                <div className={`${itemType1 === 1 ? 'item-menu-active' :'item-menu'}`} onClick={()=> {
                    handleListItemClick(1);
                    setItemType1(1);
                  }}>
                  <BpRadio {...methods.register("itemType")} checked={itemType1 === 1} onChange={()=> {
                    handleListItemClick(1);
                    setItemType1(1);
                  }} size="small" style={{marginRight:-10}}/>
                  <label>Product</label>
                </div>
                <div className={`${itemType1 === 2 ? 'item-menu-active' :'item-menu'}`} onClick={()=> {
                    handleListItemClick(2);
                    setItemType1(2);
                  }}>
                  <BpRadio {...methods.register("itemType")} checked={itemType1 === 2} onChange={()=> {
                    handleListItemClick(2);
                    setItemType1(2);
                  }} size="small" style={{marginRight:-10}}/>
                  <label>Service</label>
                </div>
                {/* Raw Material — uses the same form/labels as Product (selectedIndex 1) */}
                <div className={`${itemType1 === 3 ? 'item-menu-active' :'item-menu'}`} onClick={()=> {
                    handleListItemClick(1);
                    setItemType1(3);
                  }}>
                  <BpRadio {...methods.register("itemType")} checked={itemType1 === 3} onChange={()=> {
                    handleListItemClick(1);
                    setItemType1(3);
                  }} size="small" style={{marginRight:-10}}/>
                  <label>Raw Material</label>
                </div>
                <Divider style={{marginBottom:10}}/>
                <div className={`${selectedIndex === 3 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(3)}>
                  <label>Photos</label>
                </div> 
                <div className={`${selectedIndex === 4 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(4)}>
                  <label>Custom Fields</label>
                </div> 
                <div className={`${selectedIndex === 5 ? 'item-menu-active' :'item-menu'}`} style={{paddingTop:5}} onClick={()=>handleListItemClick(5)}>
                  <label>Linked Products</label>
                </div>
              </Grid>
              <Grid item xs={10} mr={0} pr={1} mt={2} style={{borderLeft:'1px solid #e9ecf1',minHeight:595, overflowY:'hidden', overflowX:'hidden'}}>
            <Grid container spacing={2} mt={-4}> 

            
              {selectedIndex === 1 || selectedIndex === 2 ? <>
                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Name*</h5>
                  <TextField 
                      placeholder={selectedIndex === 1 ? "Item Name" : "Service Name"} 
                      required
                      // error={!!methods.formState.errors}
                      // helperText={methods.formState.errors.name?.message ?? ""}
                      {...methods.register("name")}
                      name='name'
                      className='c-text-field' 
                      variant="standard" 
                      sx={{width:'100%'}} 
                      // size='small'
                      InputProps={{
                      disableUnderline: true, 
                      }}
                  />
                  <p style={{color: "red"}}>{methods.formState.errors.name?.message ?? ""}</p>
                </Grid>

                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Category</h5>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                      <Autocomplete
                        id="itemCategoryOptionsAutocomplete"
                        disablePortal
                        value={itemCategoryValue}
                        options={itemCategoryOptions && itemCategoryOptions.map(e =>({ value: e.value, label: e.label }))}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, value) => onChangeCategory(value)}
                        renderOption={(props, option: {label: string, value: string}) => (
                          <li {...props} 
                          style={{
                            fontSize:14,
                            height:40,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          >
                            <span>{option.label}</span>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const categoryToEdit = itemCategoryOptions.find(cat => cat.value === option.value);
                                handleOpenCategoryModal(false, categoryToEdit, null);
                              }}
                              sx={{ 
                                color: '#488dff', 
                                minWidth: '24px', 
                                height: '24px',
                                fontWeight: 'normal',
                                '&:hover': {
                                  backgroundColor: 'rgba(72, 141, 255, 0.1)'
                                }
                              }}
                              title="Edit Category"
                            >
                              <EditIcon fontSize="small" sx={{ fontWeight: 'normal' }} />
                            </IconButton>
                          </li>
                        )}
                        classes={{ paper: classes.paper }}
                        sx={{ width: '100%'}}
                        renderInput={(params) => <TextField {...params}
                        placeholder={selectedIndex === 1 ? "Select Item Category" : "Select Service Category"}
                          required 
                          className='c-text-field' 
                          variant="standard" 
                          size='small'
                          InputProps={{...params.InputProps, disableUnderline: true}}
                        />}
                      />
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenCategoryModal(false)}
                      sx={{ color: '#488dff', minWidth: '32px', height: '32px' }}
                      title="Add Category"
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>


                <Grid item xs={4}>
                  <h5 className='c-label2'>{selectedIndex === 1 ? "Item" : "Service"} Sub Category</h5>
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ flex: 1 }}>
                      <Autocomplete
                        id="itemSubCategoryOptionsAutocomplete"
                        disablePortal
                        value={itemSubCategoryValue}
                        options={itemSubCategoryOptions && itemSubCategoryOptions.map(e =>({ value: e.value, label: e.label }))}
                        getOptionLabel={(option) => option.label}
                        onChange={(event, value) => onChangeSubCategory(value)}
                        renderOption={(props, option: {label: string, value: string}) => (
                          <li {...props} 
                          style={{
                            fontSize:14,
                            height:40,
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                          }}
                          >
                            <span>{option.label}</span>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                e.stopPropagation();
                                const subCategoryToEdit = subCategories.find(sub => sub._id === option.value);
                                console.log('Editing subcategory:', subCategoryToEdit);
                                console.log('Available subCategories:', subCategories);
                                handleOpenCategoryModal(true, null, subCategoryToEdit);
                              }}
                              sx={{ 
                                color: '#488dff', 
                                minWidth: '24px', 
                                height: '24px',
                                fontWeight: 'normal',
                                '&:hover': {
                                  backgroundColor: 'rgba(72, 141, 255, 0.1)'
                                }
                              }}
                              title="Edit Sub Category"
                            >
                              <EditIcon fontSize="small" sx={{ fontWeight: 'normal' }} />
                            </IconButton>
                          </li>
                        )}
                        classes={{ paper: classes.paper }}
                        sx={{ width: '100%'}}
                        renderInput={(params) => <TextField {...params}
                          placeholder={selectedIndex === 1 ? "Select Sub Category" : "Select Service Sub Category"}
                          className='c-text-field' 
                          variant="standard" 
                          size='small'
                          InputProps={{...params.InputProps, disableUnderline: true}}
                        />}
                      />
                    </Box>
                    <IconButton
                      size="small"
                      onClick={() => handleOpenCategoryModal(true, null, null)}
                      sx={{ color: '#488dff', minWidth: '32px', height: '32px' }}
                      title="Add Sub Category"
                    >
                      <AddIcon fontSize="small" />
                    </IconButton>
                  </Box>
                </Grid>

                <Grid item xs={12} mt={-1}>
                  <h5 className='c-label2'>Description (Optional)</h5>
                  <TextField 
                    className='c-text-field' 
                    variant="standard" 
                    multiline
                    {...methods.register("description")}
                    minRows={3}
                    maxRows={3}
                    style={{width:'100%'}}
                    // onChange={(v)=> setInvoiceItemText(v.target.value.toString(), 'description', e.id)}
                    // onDoubleClick={() => Editable(e.id, true)}
                    placeholder='Description (Optional)'
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                      },
                    }} 
                  />
                </Grid>
                <Grid item xs={12} sx={{ mt: 1 }}>
                  <FormControlLabel
                    control={<Switch checked={isStockTracked} onChange={(e) => setIsStockTracked(e.target.checked)} />}
                    label="Track stock for this item"
                  />
                  <FormControlLabel
                    control={<Switch checked={isBatchTracked} onChange={(e) => setIsBatchTracked(e.target.checked)} />}
                    label="Track batches / expiry (perishables, pharma, liquor)"
                  />
                </Grid>

                <Grid item xs={12}>
                  {/* key by item id so the editor re-hydrates per item — otherwise its
                      one-time hydration guard keeps the previous item's base unit/packs
                      (the route component is reused across edit -> edit navigations). */}
                  <UnitsPacksEditor key={inventoryId || 'new'} value={unitsInitial} onChange={setUnitsValue} />
                </Grid>

                

                

                <Grid item xs={12} mt={-1}>
                <Divider><Chip label="Pricing Details" size="small" /></Divider>
                </Grid>

                {selectedIndex === 1 ? <>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Maximum Retail Price (MRP)</h5>
                <TextField
                  className='c-text-field'
                  placeholder="Maximum Retail Price (MRP)"
                  variant="standard"
                  {...methods.register("mrp")}
                  onChange={(e) => {
                    const _mrpValue = Number(e.target.value);
                    methods.setValue("mrp", e.target.value);
                    
                    const discountPercent = Number(methods.getValues("discountPercent"));
                    if (_mrpValue && _mrpValue > 0 && discountPercent > 0) {
                      const _discountAmount = _mrpValue * discountPercent / 100;
                      methods.setValue("discountAmount", _discountAmount);
                      methods.setValue("salePrice", (_mrpValue - _discountAmount).toString());
                    }

                    if (e.target.value && mrpWarning) {
                      setMrpWarning("");
                    }
                  }}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                  <h5 className='c-label2'>Discount (%)</h5>
                  <TextField
                    className='c-text-field'
                    placeholder="Discount Percentage"
                    variant="standard"
                    type='number'
                    {...methods.register("discountPercent")}
                    style={{width:'100%'}}
                    onChange={(e) => {
                      const mrp = Number(methods.getValues("mrp"));
                      var _value =  Number(e.target.value);

                      if (_value && _value > 0) {
                        if (!mrp || mrp === 0) {
                          setMrpWarning("MRP is required to calculate discount");
                          methods.setValue("discountAmount", 0);
                        } else {
                          setMrpWarning("");
                          if (_value <= 100) {
                            var _discountAmount = mrp * _value / 100;
                            methods.setValue("discountAmount", _discountAmount);
                            methods.setValue("salePrice", (mrp - _discountAmount).toString());
                          } else {
                            methods.setValue("discountAmount", 0);
                          }
                        }
                      } else {
                        setMrpWarning("");
                        methods.setValue("discountAmount", 0);
                      }
                    }}
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                        height:28
                      },
                    }}
                  />
                  <p style={{color: "red", marginTop: 5}}>{mrpWarning}</p>
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Discount Amount</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Discount Amount"
                  variant="standard"
                  disabled
                  type='number'
                  {...methods.register("discountAmount")} 
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid>
                </> : ''}

                <Grid item xs={4} mt={-1}>
                  <h5 className='c-label2'>{Number(methods.watch("discountPercent")) > 0 ? "Discounted Sale Price" : "Sale Price"}</h5>
                  <TextField
                    className='c-text-field'
                    variant="standard"
                    style={{width:'100%'}}
                    {...methods.register("salePrice")}
                    // onChange={(value) => { methods.setValue("mrp", value.target.value.toString()) }}
                    InputProps={{
                      disableUnderline: true,
                      style:{
                        fontSize:14,
                        height:28
                      },
                      startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                      endAdornment: <InputAdornment position="end">
                        <Select
                          className='c-text-field-2'
                          value={2}
                          {...methods.register("saleWithTax")}
                          disableUnderline
                          MenuProps={{
                            PaperProps: {
                              sx: {
                                border: "1.5px solid #e9ecf1",
                                width: 120,
                                boxShadow: 'none',
                                borderRadius: '5px'
                              }
                            }
                            }}
                          style={{width:125}}
                          // size='small'
                          variant='outlined'
                          sx={{
                            boxShadow: "none",
                            fontSize:14,
                          //   height:28,
                            textAlign:'left',
                            '& .MuiOutlinedInput-input': {p: 0},
                            '& .MuiSelect-select': { p:0 },
                            marginBottom:'2px',
                            ".MuiOutlinedInput-notchedOutline": { border: 0 },
                            "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                            "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                              {
                                border: 0,
                              },
                          }}
                        >
                          <MenuItem value={1} >With Tax</MenuItem>
                          <MenuItem value={2} selected={true}>Without Tax</MenuItem>
                        </Select>
                      </InputAdornment>,
                    }}
                  />
                </Grid>
                {selectedIndex === 1 ? <>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Purchase Price</h5>
                <TextField
                  className='c-text-field'
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("purchasePrice")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="end">
                      <Select
                        className='c-text-field-2'
                        value={2}
                        disableUnderline
                        {...methods.register("purchaseWithTax")}
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              width: 120,
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                          }}
                        style={{width:125}}
                        // size='small'
                        variant='outlined'
                        sx={{
                          boxShadow: "none",
                          fontSize:14,
                        //   height:28,
                          textAlign:'left',
                          '& .MuiOutlinedInput-input': {p: 0},
                          '& .MuiSelect-select': { p:0 },
                          marginBottom:'2px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                      >
                        <MenuItem value={1}>With Tax</MenuItem>
                        <MenuItem value={2}>Without Tax</MenuItem>
                      </Select>
                    </InputAdornment>,
                  }}
                />
                </Grid>

                

                
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Discount Above Qty</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Discount Above Qty"
                  variant="standard"
                  type='number'
                  {...methods.register("discountAboveQty")} 
                  // onChange={(value) => { methods.setValue("salePrice", value.target.value.toString()) }}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid></> : ''}

                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Tax Rate(%)</h5>
                <Select
                        className='c-text-field'
                        disableUnderline
                        MenuProps={{
                          PaperProps: {
                            sx: {
                              border: "1.5px solid #e9ecf1",
                              // width: 255,
                              // marginLeft:'-29px !important',
                              boxShadow: 'none',
                              borderRadius: '5px'
                            }
                          }
                          }}
                        style={{width:'100%'}}
                        value={selectedTaxRateValue ?? ''}
                        {...methods.register("gst")}
                        onChange={(event: SelectChangeEvent<any>) => {
                          methods.setValue("gst", event.target.value);
                          setSelectedTaxRateValue(event.target.value);
                        }}
                        variant='outlined'
                        sx={{
                          boxShadow: "none",
                          // fontSize:12,
                          '& .MuiOutlinedInput-input': {p: 0.5},
                          // '& .MuiSelect-select': { p:0 },
                          marginBottom:'3px',
                          ".MuiOutlinedInput-notchedOutline": { border: 0 },
                          "&.MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                          "&.MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline":
                            {
                              border: 0,
                            },
                        }}
                      >
                       
                        {taxRateOptions && taxRateOptions.map((option)=>
                          <MenuItem value={option.value} key={option.value}>{option.label}</MenuItem>
                        )}
                        </Select>
                </Grid>

                {selectedIndex === 1 ? !wholesale ? <>
                <Grid item xs={8} mt={2}>
                    
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    onClick={()=> setWholesale(!wholesale)}>+ Add Wholesale Rate (Optional)</label>
                </Grid></>: 
                <Grid item xs={8} mt={-1}>
                <>
                <HighlightOffTwoToneIcon 
                onClick={()=> {
                    setWholesale(false);
                }} sx={{float:'right',marginTop:'0px',marginRight:-1 ,color:'#9da7b7',fontSize:20}}/>
                <Box sx={{ p: 0, border: '1px dashed grey', borderRadius:'10px', m:0, mt:1, transition:'0.5s'}} >
                <Grid container spacing={2} p={1} pt={0}>
                <Grid item xs={6} mt={-2.5}>
                <h5 className='c-label2'>Wholesale Price</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("wholeSalePrice")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="end">With Tax</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={6} mt={-2.5}>
                <h5 className='c-label2'>Wholesale Quantity</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  style={{width:'100%'}}
                  {...methods.register("wholeSaleMinQty")}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    endAdornment: <InputAdornment position="start">FT</InputAdornment>,
                  }}  
                />
                </Grid>
                </Grid>
                </Box>
                </>
                </Grid> : ''}

                <Grid item xs={12} mt={-1}>
                <Divider><Chip label={selectedIndex === 1 ? "Stock Details" : "Other Details"} size="small" /></Divider>
                </Grid>

                {selectedIndex === 1 ? <>
                {/* Sale Unit & Purchase Unit selectors disabled — the new inventory model
                    records quantities via Base Unit + Units & Packs (conversions), so these
                    legacy per-direction unit fields are no longer captured for NEW items.
                    Existing items keep their saved sale.unit/purchase.unit (edit-load still
                    repopulates them). Uncomment the block below to re-enable. */}
                {/*
                <Grid item xs={4}  mt={-1}>
                  <h5 className='c-label2'> Sale Unit</h5>
                  <Autocomplete
                    id="saleUnitOptionsAutocomplete222"
                    disablePortal
                    value={itemMeasuringUnitValue}
                    options={measuringUnitOptions && measuringUnitOptions.map(e =>({ value: e.value, label: e.label }))}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => onChangeSaleUnit(value)}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:30, borderBottom: "1px solid #cdccccb8"}}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Sale Unit"
                      required
                      className='c-text-field' 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                  />
                </Grid>

                <Grid item xs={4}  mt={-1}>
                  <h5 className='c-label2'>Purchase Unit</h5>
                  <Autocomplete
                    id="purchaseUnitOptionsAutocomplete222"
                    disablePortal
                    value={itemPurchaseUnitValue}
                    options={measuringUnitOptions && measuringUnitOptions.map(e =>({ value: e.value, label: e.label }))}
                    getOptionLabel={(option) => option.label}
                    onChange={(event, value) => onChangePurchaseUnit(value)}
                    renderOption={(props, option: {label: string}) => (
                      <li {...props} 
                      style={{fontSize:14,height:30, borderBottom: "1px solid #cdccccb8" }}
                      >{option.label}</li>
                    )}
                    classes={{ paper: classes.paper }}
                    sx={{ width: '100%'}}
                    renderInput={(params) => <TextField {...params}
                      placeholder="Select Sale Unit"
                      required
                      className='c-text-field' 
                      variant="standard" 
                      size='small'
                      InputProps={{...params.InputProps, disableUnderline: true}}
                    />}
                  />
                </Grid>
                */}

                {/* <Grid item xs={12}>
                  <UnitsPacksEditor value={unitsInitial} onChange={setUnitsValue} />
                </Grid> */}
                
                {/* Opening Stock & As Of Date disabled — initial stock is now brought in
                    per (location × batch) via Goods Receipt / Stock Adjustment, not as a
                    location-less number on the item. Existing items keep their saved values.
                    Uncomment the block below to re-enable. */}
                {/*
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Opening Stock
                  {isEditing && <Tooltip title="You cannot update opening stock. If you want udpate the stock please use Adjust Stock"><InfoIcon size={14} style={{ color: '#09b2ee', verticalAlign: 'middle', marginLeft: 4 }}></InfoIcon></Tooltip>}</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard"
                  type='number'
                  style={{width:'100%'}}
                  disabled={isEditing}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    }
                  }} 
                  {...methods.register("openingStock")} 
                />
                </Grid>

                <Grid item xs={4} mt={-1} >
              <h5 className='c-label2'>As Of Date *</h5>
              <DesktopDatePicker
                inputFormat="dd/MM/yyyy"
                maxDate={moment().add(1).toDate()}
                value={stockAsOfDate}
                
                InputProps={{
                  disableUnderline: true,
                  style:{
                    fontSize:14,
                    height:28
                  },
                }}
                onChange={(value) => { handleDateChange(value, 'stockAsOfDate') }}
                renderInput={(params) => 
                  <TextField {...params}
                    {...methods.register("stockAsOfDate")} 
                    style={{width:'100%'}}
                    required 
                    variant="standard"
                    className='c-text-field'
                    placeholder="Invoice Date"
                    
                  />}
              />
              </Grid>
                */}
              </> : ''}

              <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>{selectedIndex === 1 ? "Item Short code" : "Service Short code"}</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={selectedIndex === 1 ? "Item Short code" : "Service Short code"}
                  variant="standard"
                  {...methods.register("itemShort")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>

              <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>{selectedIndex === 1 ? "Item Code" : "Service Code"}</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={selectedIndex === 1 ? "Item Code" : "Service Code"}
                  variant="standard"
                  {...methods.register("itemCode")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>

              <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>{selectedIndex === 2 ? 'SAC' : 'HSN'} Code</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder={selectedIndex === 2 ? 'SAC Code' : 'HSN Code'}
                  variant="standard"
                  {...methods.register("hsnCode")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}
                />
                </Grid>

              {selectedIndex === 1 ? !lowStock ? <>
                <Grid item xs={4} mt={2}>

                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    onClick={()=> setLowStock(!lowStock)}>+ Add Low Stock Quantity (Optional)</label>
                </Grid></>:
                <Grid item xs={4} mt={-1}>
                <>
                <HighlightOffTwoToneIcon
                onClick={()=> {
                    setLowStock(false);
                }} sx={{float:'right',marginTop:'0px',marginRight:-1 ,color:'#9da7b7',fontSize:20}}/>
                <Box sx={{ p: 0, border: '1px dashed grey', borderRadius:'10px', m:0, mt:1, transition:'0.5s' }} >
                <Grid container spacing={2} p={1} pt={0}>
                <Grid item xs={lowStockUnitOptions.length ? 6 : 12} mt={-2.5}>
                <h5 className='c-label2'>Low Stock Quantity</h5>
                <TextField
                  className='c-text-field'
                  variant="standard"
                  {...methods.register("lowStockQuantity")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    }
                  }}
                />
                </Grid>
                {/* Hidden until the item has a base unit — nothing to convert against otherwise. */}
                {lowStockUnitOptions.length ? <Grid item xs={6} mt={-2.5}>
                <h5 className='c-label2'>Unit</h5>
                <Autocomplete
                  id="lowStockUnitAutocomplete"
                  disablePortal
                  value={lowStockUnitValue}
                  options={lowStockUnitOptions.map((e: any) => ({ value: e.value, label: e.label }))}
                  getOptionLabel={(option: any) => option.label}
                  isOptionEqualToValue={(option: any, value: any) => String(option.value) === String(value?.value)}
                  onChange={(event, value) => setLowStockUnitValue(value)}
                  renderOption={(props, option: {label: string}) => (
                    <li {...props} style={{fontSize:14,height:30, borderBottom: "1px solid #cdccccb8"}}>{option.label}</li>
                  )}
                  classes={{ paper: classes.paper }}
                  sx={{ width: '100%'}}
                  renderInput={(params) => <TextField {...params}
                    placeholder={unitsValue.baseUnitName || "Select Unit"}
                    className='c-text-field'
                    variant="standard"
                    size='small'
                    InputProps={{...params.InputProps, disableUnderline: true}}
                  />}
                />
                </Grid> : ''}
                </Grid>
                </Box>
                </>
                </Grid> : ''}

                </> : ''}

                {selectedIndex === 1 ? <>
                  <Grid item xs={12} mt={1}>
                    <Divider><Chip label={"Variants"} size="small" /></Divider>
                  </Grid>
                  <Grid item xs={12}>
                    {/* key by item id so the section re-hydrates per item (route reused across edits) */}
                    <SkuVariantsSection key={inventoryId || 'new'} value={variantsInitial} onChange={setVariantsValue} />
                  </Grid>
                </> : ''}

                {selectedIndex === 1 ? <>
                  <Grid item xs={12} mt={1}>
                    <Divider><Chip label={"Barcode Details"} size="small" /></Divider>
                  </Grid>
                  <SkuBarcodePanel
                    isEditing={isEditing}
                    skuId={inventoryId}
                    mode={methods.watch('barcodeMode') || 'none'}
                    onModeChange={(m) => methods.setValue('barcodeMode', m)}
                    manufacturerBarcode={methods.watch('manufacturerBarcode') || ''}
                    onManufacturerBarcodeChange={(v) => methods.setValue('manufacturerBarcode', v)}
                  />
                </> : ''}

                {selectedIndex === 3 ? <>
                  <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Item Photos"} size="small" /></Divider>
                </Grid>
                <div style={{padding:20}}>
                <FileUploader
                  images={images}
                  title='Upload Photos'
                  size={5}
                  setImages={setImages}
                ></FileUploader></div> </>: ''}

                {selectedIndex === 4 ? <>

                <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Additional Fields"} size="small" /></Divider>
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Brand</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Brand"
                  variant="standard"
                  {...methods.register("brand")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Color</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Color"
                  variant="standard"
                  {...methods.register("color")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // endAdornment: selectedIndex === 1 ? <InputAdornment position="start"><a style={{paddingBottom:3,fontSize:14}}>Generate Barcode</a></InputAdornment> : '',
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Store Location</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Store Location"
                  variant="standard"
                  {...methods.register("storeLocation")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={-1}>
                <h5 className='c-label2'>Store Name</h5>
                <TextField 
                  className='c-text-field' 
                  placeholder="Store Name"
                  variant="standard"
                  {...methods.register("storeName")}
                  style={{width:'100%'}}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                  }}  
                />
                </Grid>

                <Grid item xs={12} mt={0}>
                <Divider><Chip label={"Custom Fields"} size="small" /></Divider>
                </Grid>

                <Grid item xs={4} mt={0}>
                <h5 className='c-label2'>Custom Field Name</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                //   size='small'
                  style={{width:'100%'}}
                //   value={invoice.receivedAmt}
                //   onChange={(e) => {
                //     const s = {...invoice};
                //     s.receivedAmt = e.target.value;
                //     setInvoice(s)
                //   }}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="end">With Tax</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={0}>
                <h5 className='c-label2'>Custom Field Value</h5>
                <TextField 
                  className='c-text-field' 
                  variant="standard" 
                //   size='small'
                  style={{width:'100%'}}
                //   value={invoice.receivedAmt}
                //   onChange={(e) => {
                //     const s = {...invoice};
                //     s.receivedAmt = e.target.value;
                //     setInvoice(s)
                //   }}
                  InputProps={{
                    disableUnderline: true,
                    style:{
                      fontSize:14,
                      height:28
                    },
                    // startAdornment: <InputAdornment position="start"><b style={{paddingBottom:3,fontSize:14}}>&nbsp;&nbsp;₹</b></InputAdornment>,
                    // endAdornment: <InputAdornment position="start">FT</InputAdornment>,
                  }}  
                />
                </Grid>
                <Grid item xs={4} mt={3}>
                    <label className="c_label" style={{color:'#488dff',cursor:'pointer',fontSize:14}}
                    // onClick={()=> setLowStock(!lowStock)}
                    >+ Add Another Field</label>
                </Grid>
                </> : ''}

                {selectedIndex === 5 ? <>
                  <Grid item xs={12} mt={0}>
                    <Alert severity="info" style={{fontSize: 16}}>Select list of products for cross selling. This feature allows you to suggest linked items while adding items to invoice from inventory</Alert>
                  </Grid>
                  <Grid item xs={12} mt={0}>
                    <h5 className='c-label2'>Link Products (Cross-sell)</h5>
                    <Autocomplete
                      id="parentSkusOptionsAutocomplete"
                      multiple
                      disablePortal
                      value={selectedParentSkuTags}
                      options={skuOptions && skuOptions.map(e =>({ value: e.value, label: e.label }))}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => onChangeTagSkus(value)}
                      renderOption={(props, option: {label: string}) => (
                        <li {...props}
                        style={{fontSize:14}}
                        >{option.label}</li>
                      )}
                      classes={{ paper: classes.paper }}
                      sx={{ width: '100%'}}
                      renderInput={(params) => <TextField {...params}
                      placeholder={"Select products to link"}
                        style={{height: 'auto'}}
                        className='c-text-field-4'
                        variant="standard"
                        size='small'
                        InputProps={{...params.InputProps, disableUnderline: true}}
                      />}
                    />
                  </Grid>

                  <Grid item xs={12} mt={2}>
                    <h5 className='c-label2'>Tags</h5>
                    <Autocomplete
                      id="itemTagsAutocomplete"
                      multiple
                      disablePortal
                      disableCloseOnSelect
                      value={(masterTags || [])
                        .filter((t: any) => selectedTagIds.includes(t._id))
                        .map((t: any) => ({ value: t._id, label: t.name, color: t.color }))}
                      options={(masterTags || []).map((t: any) => ({ value: t._id, label: t.name, color: t.color }))}
                      isOptionEqualToValue={(option, value) => option.value === value.value}
                      getOptionLabel={(option) => option.label}
                      onChange={(event, value) => setSelectedTagIds(value.map((v: any) => v.value))}
                      renderOption={(props, option: any, { selected }) => (
                        <li {...props}
                        style={{fontSize:14, display:'flex', alignItems:'center', gap:4}}
                        >
                          <Checkbox size="small" checked={selected} style={{ padding: 4 }} />
                          <span style={{ width:10, height:10, borderRadius:'50%', backgroundColor: option.color || '#7f8c9b', display:'inline-block', flexShrink:0 }} />
                          {option.label}
                        </li>
                      )}
                      renderTags={(value: any[], getTagProps) =>
                        value.map((option: any, index: number) => (
                          <Chip
                            {...getTagProps({ index })}
                            key={option.value}
                            label={option.label}
                            size="small"
                            sx={{
                              backgroundColor: option.color || '#7f8c9b',
                              color: '#fff',
                              '& .MuiChip-deleteIcon': { color: 'rgba(255,255,255,0.8)' },
                            }}
                          />
                        ))
                      }
                      classes={{ paper: classes.paper }}
                      sx={{ width: '100%'}}
                      renderInput={(params) => <TextField {...params}
                      placeholder={"Select tags"}
                        style={{height: 'auto'}}
                        className='c-text-field-4'
                        variant="standard"
                        size='small'
                        InputProps={{...params.InputProps, disableUnderline: true}}
                      />}
                    />
                  </Grid>
                  <div style={{padding:20}}>

                  </div>
                  </> : ''
                }

            </Grid>
            </Grid>
            </Grid>
              {/* <Typography>some text goess here {JSON.stringify(stateOptions)}</Typography> */}
            </LocalizationProvider>
          </Box>
        {/* </CardContent> */}
        
        {/* Category Modal */}
        {categoryModalOpen && (
          <CategoryModal
            open={categoryModalOpen}
            onClose={handleCloseCategoryModal}
            onSuccess={refreshCategoriesData}
            editingCategory={editingCategory}
            editingSubCategory={editingSubCategory}
            selectedCategoryId={itemCategoryId}
            categories={itemCategoryOptions}
            isSubCategory={isSubCategoryModal}
          />
        )}
      </FormProvider>
  );
}

export default InventoryFormNew;